module.exports = __webpack_public_path__ + "img/category_early_diagnosis.881c748.svg";